/**
 * 拼团切换门店
 */
import React from 'react'
import { observer } from 'mobx-react'
import { Icon } from '@cps'
import CashierController from '@ctrls/cashierController'
import './index.scss'

export interface IEatTypeSwitcherProps {
  eatType: TEntryType;
  store: IViewStore;
  onChange?: (value: IViewStore) => void;
}

const SelectStore: React.FC<IEatTypeSwitcherProps> = (props) => {
  const history = CashierController.history()
  const { eatType, store, onChange } = props
  const handleClick = () => {
    history.push('/store', null, { tt: 'buyTogether' })
  }
  return (
    <div className='multi-spell-store-select-container'>
      <div className='title'><Icon name='mendian1' />{i18n.t(`menu.buyTogether.store_${eatType}`)}</div>
      <div className='multi-spell-store-wrapper' onClick={handleClick}>
        {
          store.storeId ? (
            <div className='multi-spell-store-wrap'>
              <div className='store-name-wrap'>
                <span className='store-name'>{store.storeName}</span>
              </div>
              {!store.inSale && (
                <div className='store-count-down'>
                  <span className='rest-tag'>{i18n.t('store.resting')}</span>
                </div>
              )}
              <div className='store-location'>
                <span>{store.address}{store.addressDetails}</span>
              </div>
            </div>
          ) : (
            <div className='multi-spell-store-wrapper'>
              <div className='store-location'>
                <span className='empty-txt'>{i18n.t('menu.choose_store_then_order')}</span>
              </div>
            </div>
          )
        }
        <Icon name='change' />
      </div>
    </div>
  )
}

export default observer(SelectStore)
